import { findNodeByPath } from './computeGroupTree'

// Paletová utilita pro barevný mód „Podle skupiny“ na mapě (viz doc/plans/station-group-layout.md sekce III)
export const GROUP_COLOR_PALETTE = [
  '#2196f3', '#ff9800', '#4caf50', '#e91e63', '#9c27b0',
  '#00bcd4', '#ff5722', '#795548', '#607d8b', '#cddc39',
  '#3f51b5', '#f44336', '#009688', '#8bc34a', '#673ab7',
]

// children = pole { label, ghIds: Set } — přímé děti vybraného uzlu (viz computeGroupTree.buildGroupTree)
// colorOffset — posun v paletě, použito při skládání víc uzlů dohromady (viz buildGroupColorMapFromPaths)
// Vrací { colorByGhId: Map<gh_id, color[]>, legend: [{ color, label }] } — stanice patřící do víc
// dětských skupin naráz (překryv) dostane víc barev, StationMap je pak zobrazí jako koláč.
export function buildGroupColorMap(children, colorOffset = 0) {
  const colorByGhId = new Map()
  const legend = children.map((child, i) => ({
    color: GROUP_COLOR_PALETTE[(colorOffset + i) % GROUP_COLOR_PALETTE.length],
    label: child.label,
  }))
  children.forEach((child, i) => {
    const color = GROUP_COLOR_PALETTE[(colorOffset + i) % GROUP_COLOR_PALETTE.length]
    for (const ghId of child.ghIds) {
      const existing = colorByGhId.get(ghId)
      if (existing) existing.push(color)
      else colorByGhId.set(ghId, [color])
    }
  })
  return { colorByGhId, legend }
}

// Varianta pro filtr „Skupina" ve výběru 1 stanice (StationSelectLayout) — na rozdíl od
// StationGroupLayout (1 vybraný uzel ve stromu) tu uživatel může zaškrtnout víc uzlů napříč
// uloženými skupinami naráz (groupPaths). Pro každý vybraný uzel se použije STEJNÁ logika jako
// tam — obarví se podle jeho přímých dětí (buildGroupColorMap), list bez dětí dostane 1 barvu.
// Barvy se přidělují napříč všemi vybranými uzly plynule, aby při víc vybraných uzlech nekolidovaly.
// trees = [{ id, name, tree }] z useSavedGroupTrees, groupPaths = filters.groupPaths
// (pole cest [savedGroupId, bucketLabel, ...], viz resolveGroupPaths).
export function buildGroupColorMapFromPaths(trees, groupPaths) {
  if (!groupPaths || groupPaths.length === 0) return { colorByGhId: null, legend: null }
  const treeById = new Map(trees.map(t => [t.id, t]))
  const colorByGhId = new Map()
  const legend = []
  let colorOffset = 0

  groupPaths.forEach(path => {
    const [groupId, ...labels] = path
    const group = treeById.get(groupId)
    if (!group) return

    let node
    if (labels.length === 0) {
      // celá uložená skupina = virtuální uzel se všemi kořeny jako dětmi
      if (group.tree.length === 0) return
      node = { label: group.name, children: group.tree }
    } else {
      node = findNodeByPath(group.tree, labels.map(bucketLabel => ({ bucketLabel })))
      if (!node) return
    }

    // Víc vybraných uzlů může sdílet stejný label podskupiny (např. "Ostatní" v různých větvích) —
    // prefix rodičovským labelem jen když je vybráno víc uzlů, ať legenda zůstává jednoznačná.
    const prefix = groupPaths.length > 1 ? `${node.label}: ` : ''
    const units = node.children?.length > 0 ? node.children : [node]
    const { colorByGhId: partial, legend: partialLegend } = buildGroupColorMap(units, colorOffset)

    for (const [ghId, colors] of partial) {
      const existing = colorByGhId.get(ghId)
      if (existing) existing.push(...colors)
      else colorByGhId.set(ghId, [...colors])
    }
    for (const item of partialLegend) legend.push({ ...item, label: `${prefix}${item.label}` })
    colorOffset += units.length
  })

  return { colorByGhId, legend }
}
